import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const set_user_login = createAsyncThunk('set_user_login', async (body) => {
    sessionStorage.setItem("LOGIN_TOKEN", body['token']);
    sessionStorage.setItem("USER_CODE", body['code']);
    sessionStorage.setItem("USER_TYPE", body['type']);

    localStorage.setItem("LOGIN_TOKEN", body['token']);
    localStorage.setItem("USER_CODE", body['code']);
    localStorage.setItem("USER_TYPE", body['type']);

    return 1;
});

export const check_user_login = createAsyncThunk('check_user_login', async () => {
    const token = localStorage.getItem("LOGIN_TOKEN");
    console.log("check_user_login", token);
    if (token != null) {
        sessionStorage.setItem("LOGIN_TOKEN", localStorage.getItem("LOGIN_TOKEN"));
        sessionStorage.setItem("USER_CODE", localStorage.getItem("USER_CODE"));
        sessionStorage.setItem("USER_TYPE", localStorage.getItem("USER_TYPE"));
        return 1;
    } else {
        return 0;
    }
});

export const remove_user_login = createAsyncThunk('remove_user_login', async () => {
    sessionStorage.removeItem("LOGIN_TOKEN");
    sessionStorage.removeItem("USER_CODE");
    sessionStorage.removeItem("USER_TYPE");

    localStorage.removeItem("LOGIN_TOKEN");
    localStorage.removeItem("USER_CODE");
    localStorage.removeItem("USER_TYPE");
    return 0;
});

const UserLoginSlice = createSlice({
    name: "login_slice",
    initialState: {
        isLogin: false,
        isChecked: false
    },
    extraReducers: builder => {
        builder.addCase(set_user_login.fulfilled, (state, action) => {
            state.isChecked = true;
            if (action.payload === 1) {
                state.isLogin = true;
            } else {
                state.isLogin = false;
            }
        });
        builder.addCase(check_user_login.fulfilled, (state, action) => {
            state.isChecked = true;
            if (action.payload === 1) {
                state.isLogin = true;
            } else {
                state.isLogin = false;
            }
        });
        builder.addCase(remove_user_login.fulfilled, (state, action) => {
            state.isChecked = true;
            if (action.payload === 1) {
                state.isLogin = true;
            } else {
                state.isLogin = false;
            }
        });
    }
});

export default UserLoginSlice.reducer;